import rolesSlice from './rolesSlice';

export * from './thunks';

export default rolesSlice;
